<dashboard-dialog-frame [icon]='icon()' header='Configure Topic' [actions]='actions' [dialogRef]='dialogRef'>

	<div class="acc-delivery-topics-configure-topic-dialog">
		<readonly-access [readonly]="isReadonly()"></readonly-access>
		@if(topic(); as topic){
		<table style='width:100%' class='pro-table pro-table-no-header pro-table-with-labels pro-table-without-border'>
			<tr>
				<td>Topic </td>
				<td>
					{{ topic.topic }}
				</td>
			</tr>
			@if(topic.needsSpecialist){
			<tr>
				<td>Specialists</td>
				<td>
					<kendo-multiselect [data]='topic.list' [value]="newSelectedSpecialistIds()"
						(valueChange)="specialistsChange($event)" [autoClose]="false" [textField]="'personName'"
						[valueField]="'personId'" [valuePrimitive]="true" [checkboxes]="true">
					</kendo-multiselect>
				</td>
			</tr>
			}
		</table>
		}
	</div>

</dashboard-dialog-frame>